import { getNumberFromCurrency } from './general'

/**
 * Checks if the amount raised in the current round is greater than or equal to the total round size.
 *
 * @param {string} raised - The amount raised in the current round (formatted as currency).
 * @param {string} round_size - The total round size (formatted as currency).
 * @returns {boolean} - True if the amount raised is greater than or equal to the total round size, false otherwise.
 */
export function isDisplayRaisedGreaterOrEqualToRoundSize(raised, round_size) {
  const raisedThisRound = getNumberFromCurrency(raised)
  const totalRoundSize = getNumberFromCurrency(round_size)

  // Ignore the case where the raisedThisRound and totalRoundSize values
  // cannot have the number value extracted from the strings.
  if (raisedThisRound == null || totalRoundSize == null) {
    return false
  }

  return raisedThisRound >= totalRoundSize
}

/**
 * Calculates the current step in the startup onboarding process based on user information.
 *
 * @param {Object} startupUser - Information about the startup user.
 * @param {boolean} isEmailConfirmed - Indicates whether the user's email is confirmed.
 * @returns {number} - The current step in the onboarding process.
 */
export function calcCurrentStartupStep(startupUser, isEmailConfirmed) {
  if (!startupUser.first_name) {
    return 1
  }
  /*
    Check that the email is neither confirmed via a confirmation link
    not confirmed via the user's email_confirmed field.
  */
  if (!(isEmailConfirmed || startupUser.email_confirmed)) {
    return 2
  } else {
    return 2
  }
}
